module.exports = __webpack_public_path__ + "static/media/common-setting.27cee71b.svg";